import Box from "@mui/material/Box";
import { get, isEmpty } from "lodash";
import { Fragment, useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { connect } from "react-redux";
import { matchRoutes, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import Styles from "../../theme/commonCss/Styles";
import DashboardLoader from "../../common/DashboardLoader";
import { ReactComponent as DashboardImage } from '../../assets/icons/main/dashboard-image.svg';
import { ReactComponent as PlusCircleIcon } from '../../assets/icons/main/plus-circle-icon.svg';
import { Button, Container, Paper, Typography, useTheme } from "@mui/material";

// function onLoad(e: any) {
//   const contWin = get(e, 'target.contentWindow');
//   try {
//     contWin.addEventListener(
//       'keydown',
//       function (event: any) {
//         if (event.keyCode === 27 || event.keyCode === 70) {
//           event.preventDefault();
//           event.stopPropagation();
//           return false;
//         }
//       },
//       true
//     );
//   } catch (err) {
//     console.log(err);
//   }
// }

function Home({ userAccess }: any) {
  const auth = useAuth();
  const themeData = useTheme();
  const { reqType } = useParams();
  const hasNoAccessToCreate = !get(userAccess, `use_case.create`, false);
  const navigate = useNavigate();

  return (
    <Fragment>
      {reqType && reqType != '' ? (
        <Container maxWidth={false} disableGutters sx={Styles.masterContainer}>
          <Paper
            sx={{
              ...Styles.masterPaperContainer,
              border: `1px solid  ${themeData.palette.customBorderColor.main}`,
              backgroundColor: 'transparent',
            }}
          >
            <Box
              sx={{
                minHeight: 'calc(100vh - 183px)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <DashboardImage />
              {reqType && reqType === 'access-denied' ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography sx={{ mb: 2, mt: 3 }}>Access Restricted</Typography>
                  <Typography variant='body2' sx={{ color: '#6b7a99', fontWeight: 500, textAlign: 'center' }}>
                    You do not have permission to access the Dashboard. <br></br>
                    Please contact an administrator to request access.
                  </Typography>
                </Box>
              ) : (
                <Fragment>
                  <Typography
                    variant='h5'
                    sx={{ mb: 2, mt: 3, textAlign: 'center', color: '#6b7a99', fontWeight: 500 }}
                  >
                    No Dashboard Found
                  </Typography>
                  <Button
                    variant='contained'
                    onClick={() => navigate('/usecase-management')}
                    disabled={hasNoAccessToCreate}
                  >
                    <PlusCircleIcon />
                    Create a new one now
                  </Button>
                </Fragment>
              )}
            </Box>
          </Paper>
        </Container>
      ) : (
        <DashboardLoader />
      )}
    </Fragment>
  );
  // return (
  //   /(archit|vinayak)/i.test(auth?.user?.profile?.name ?? '') ?
  //     <iframe frameBorder={0} src={`http://${window.location.hostname}/grafana/public-dashboards/486b66749e4c4998a2a786af5ba3fdfb?orgId=1?refresh=5s&theme=light`} style={{minHeight: `calc(100vh - 323.33px)`, width: '100%'}} />
  //   : <h6>Dashboard content</h6>
  // );

  // if (/(archit|vinayak|madupusai|ashwin|rahul|ashish|sai|omkar|abhilash)/i.test(auth?.user?.profile?.name ?? '')) {
  //   return (
  //     <Box
  //       sx={{
  //         ...Styles.masterPaperContainer,
  //         border: `1px solid #D9DFED`,
  //         backgroundColor: '#fff',
  //         overflow: 'hidden',
  //         height: 'calc(100vh - 185px)',
  //       }}
  //     >
  //       <iframe
  //         title='Grafana'
  //         // src={`http://demdlx261as401.ad.harman.com/grafana?kiosk&refresh=5s&theme=light`}
  //         // src={`http://inphwn179662:3005/d/eekgvvg13ot1cd/pepsi-monitoring?orgId=1&from=now-30m&to=now&timezone=browser`}
  //         src={`http://ec2-13-127-207-214.ap-south-1.compute.amazonaws.com:30300/public-dashboards/33ba451067fe4d8b82da3fcf12ec3605?orgId=1&from=now-5m&to=now&timezone=browser`}
  //         style={{ width: '100%', height: '100%', border: 'none' }}
  //         // onLoad={onLoad}
  //       />
  //     </Box>
  //   );
  // } else {
  //   return <h6>Dashboard content</h6>;
  // }
}

const mapStateToProps = (state: any) => ({
  settingsData: state.settings.settingsData,
  userAccess: state.profile.userAccess,
});

export default connect(mapStateToProps)(Home);
